export default __webpack_public_path__ + "static/media/ZoneAndPOI.1b61efc5.svg";